import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { CheckDuplicatePenPipeSize, PenPipeSizeDto } from 'models/pen/PenPipeSize';
import { ErrorService } from 'services/error-service';
import { PenPipeSizeService } from 'services/pen/pen-pipe-size-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PenPipeSizeDetail {
  private penPipeSize: PenPipeSizeDto;
  protected checkDuplicateData: CheckDuplicatePenPipeSize = new CheckDuplicatePenPipeSize();

  private constructor(
    private penPipeSizeService: PenPipeSizeService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private toastService: ToastService,
    private router: Router
  ) {}

  protected async activate(params: { Id: string }) {
    try {
      this.penPipeSize = await this.penPipeSizeService.get(params.Id);
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  @AsyncErrorHandler
  async updatePenPipeSize() {
    if (await this.checkDuplicate()) return;

    this.penPipeSize.Name = this.penPipeSize.Size.toString();
    await this.penPipeSizeService.put(this.penPipeSize, this.penPipeSize.Id);
    this.eventAggregator.publish('penPipeSizesReset', 1);
    this.toastService.showSuccess('pens.penPipeSizeUpdated');
    this.router.navigateToRoute('pen-pipe-size-list');
  }

  protected gotoParentView() {
    this.eventAggregator.publish('penPipeSizesReset', 1);
    this.router.navigateToRoute('pen-pipe-size-list');
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.Id = this.penPipeSize.Id;
    this.checkDuplicateData.Size = this.penPipeSize.Size;
    const { IsDuplicate } = await this.penPipeSizeService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('penPipeSizeIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
